import { useContext } from "react";
import type { AgentContextValue } from "@/client/contexts/agent";
import { AgentContext } from "@/client/contexts/agent";

export function useAgent(): AgentContextValue {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error("useAgent must be used within AgentProvider");
  }
  return context;
}
